export const SUPPORTING_DOC_ADDED = 'SUPPORTING_DOC_ADDED';

function supportingDocAdded(newSupportingDoc) {
  return {
    type: SUPPORTING_DOC_ADDED,
    newSupportingDoc
  };
}

export function addSupportingDoc(newSupportingDoc) {
  return dispatch => dispatch(supportingDocAdded(newSupportingDoc));
}
